module.exports = __webpack_public_path__ + "static/media/sms-inactive.7d371696.svg";